import { defineStore } from 'pinia'
import { getCartList } from '~/api/mall'
import config from '~/config/index'

const STORE_UNSAFE_KEYS = new Set([
  'hasOwnProperty',
  '__proto__',
  'constructor',
  'prototype',
])

function toPlainSerializable(value, seen = new WeakMap()) {
  if (Array.isArray(value)) {
    return value.map(item => toPlainSerializable(item, seen))
  }

  if (value && typeof value === 'object') {
    if (seen.has(value)) {
      return seen.get(value)
    }

    const result = {}
    seen.set(value, result)

    return Object.keys(value).reduce((acc, key) => {
      if (STORE_UNSAFE_KEYS.has(key)) {
        return acc
      }

      acc[key] = toPlainSerializable(value[key], seen)
      return acc
    }, result)
  }

  return value
}

function normalizeCartQuantity(item) {
  const quantity = Number(item?.buyAmount ?? item?.qty ?? item?.quantity ?? item?.count ?? 0)
  return Number.isFinite(quantity) ? quantity : 0
}

export const useCartStore = defineStore('cartStore', {
  state: () => ({
    cartNum: 0,
    cartList: [],
    cartTotalQuantity: 0,
  }),
  actions: {
    getCartInfo() {
      return {
        cartList: this.cartList,
        cartNum: this.cartNum,
        cartTotalQuantity: this.cartTotalQuantity,
      }
    },
    async getCartData() {
      const appToken = window.localStorage.getItem(config.appTokenKey)

      let cartList = []
      if (appToken) {
        const responseCartList = await getCartList()
        cartList = responseCartList.data.dataList
      }
      else {
        const localCartData = window.localStorage.getItem('local_cart_items')
        if (localCartData) {
          cartList = JSON.parse(localCartData)
        }
      }
      const nextCartList = toPlainSerializable(Array.isArray(cartList) ? cartList : [])
      this.cartList = nextCartList
      this.cartNum = nextCartList.length
      this.cartTotalQuantity = nextCartList.reduce((acc, item) => acc + normalizeCartQuantity(item), 0)
    },
    async addToCart() {

    },
    async removeFromCart() {

    },
  },
})
